module.exports = __webpack_public_path__ + "01_veryshort_black.a73fb8e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/01_veryshort_black.png
// module id = sjSQ
// module chunks = 0